export default __webpack_public_path__ + "static/media/beforeLoginBg.edf06592.svg";